



import Vue from "vue";
import { judgeUa } from "@/utils/detect";

export default Vue.extend({
  methods: { judgeUa }
});
